module.exports = __webpack_public_path__ + "img/farming_35.8eab0eaf.png";